import * as React from 'react';
import { InjectedRouter, RouterState } from 'react-router';

import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import CenteredContainer from 'components/CenteredContainer';
import Columns2 from 'components/Columns2';
import EventTracking from 'lib/EventTracking';
import Group from 'entities/Group';
import GroupAvatar from 'groups/components/GroupAvatar';
import GroupName from 'groups/components/GroupName';
// @ts-ignore
import JoinGroupFormPanel from './JoinGroupFormPanel';
import JoinGroupAvatarPanel from './JoinGroupAvatarPanel';
import LoadingModal from 'components/LoadingModal';
import Text from 'components/Text';
import TitleHeader from 'components/TitleHeader';
import { withRouter } from 'app/context/Router';

import GroupDataOps from 'groups/lib/GroupDataOps';

import './styles/JoinGroupPage.scss';

type Props = {
  group?: Group,
  loading: boolean,
  router: InjectedRouter & RouterState,
};

class JoinGroupPage extends React.Component<Props> {
  componentDidMount() {
    EventTracking.trackKey('join_group_page.sign_up.view');
  }

  render() {
    const { group, router } = this.props;
      const { groupCode } = router.params;

    // XXX - This is to fix https://my.trackjs.com/details/9a7be15d01bd4ae98c41d04c4148a8aa.
    // Somehow we're ending up with an empty group here sometimes
    if (GroupDataOps.hasIdOrUuid(group) === false) {
      console.warn('Trying to render an empty group');
      return null;
    }

    const groupAvatarComponent = <GroupAvatar group={group} />;

    if (!group) {
      console.warn('error loading group');
      router.replace(`/join?notFound=${groupCode}`);
      return null;
    }

    return (
      <CenteredContainer size="large">
        <Box>
          <BoxBody>
            <TitleHeader
              title={
                <span>
                  Join {GroupDataOps.getPossessiveSignature(group)}
                  <Text element="div" weight="semibold">
                    <GroupName group={group} />
                  </Text>
                </span>
              }
              subtext={GroupDataOps.getOrganizationName(group)}
              className="JoinGroupPage-title"
            />
            <Columns2 flex reset="tablet" resetFlush>
              <div>
                <JoinGroupAvatarPanel
                  groupAvatar={groupAvatarComponent}
                  possessiveSignature={group.getPossessiveSignature()}
                  orgName={GroupDataOps.getOrganizationName(group)}
                  groupCode={`@${group.getCodeOrError()}`}
                  className={GroupDataOps.getClassName(group)}
                />
              </div>
              <JoinGroupFormPanel group={group} />
            </Columns2>
          </BoxBody>
        </Box>
      </CenteredContainer>
    );
  }
}

type ConnectJoinGroupState = {
  group?: Group,
  loading: boolean,
  router: InjectedRouter & RouterState,
};

// TEMP until we can get this by GraphQL
function withGroup(WrappedComponent: React.ComponentType<Props>) {
  return class ConnectJoinGroupPage extends React.Component<
    ConnectJoinGroupState
  > {
    state = {
      group: undefined,
      loading: true,
    };

    componentDidMount() {
      const { router } = this.props;
      const { groupCode } = router.params;

      const cleanGroupCode = GroupDataOps.parseAcceptableGroupCode(groupCode);

      if (cleanGroupCode) {
        Group.fetchByCode(cleanGroupCode).then(
          group => {
            if (group && GroupDataOps.canJoin(group)) {
              this.setState({ group, loading: false });
            } else {
              router.replace('/error');
              throw new Error('Cannot join group');
            }
          },
          err => {
            console.warn('error loading group', err);
            router.replace(`/join?notFound=${groupCode}`);
          }
        );
      } else {
        router.replace(`/join?notFound=${groupCode}`);
        throw new Error('invalid group code');
      }
    }

    render() {
      if (this.state.loading) {
        return <LoadingModal />;
      }
      return <WrappedComponent {...this.props} {...this.state} />;
    }
  };
}
export default withRouter(withGroup(JoinGroupPage));
